import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import InputLayout from "../../../atoms/InputLayout";
import * as Yup from "yup";
import CountryCodeDropdown from "../../../molecules/Dropdown/CountryCodeDropdown";
import Error from "../../../atoms/Error";
import { postData, patchData, putData } from "../../../../services";
import { useCookies } from "react-cookie";
import toast from "react-hot-toast";
import {
  confimationStyles,
  errorStyles,
} from "../../../../assets/styles/toast";
import FormObserver from "../../../../helpers/FormObserver";
import SelectDropdown from "../../../molecules/Dropdown";
import { getEmployeeList } from "../../../../services/basicGets";


const TeamForm = ({ onFormDirty, initialData, onClose, refetchData,isAdmin  }) => {
  const [cookies] = useCookies(["e_t"]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // State to store filtered employee list (without the team lead)
 
  const [employeeList, setEmployeeList] = useState([]);
   const [filteredEmployeeList, setFilteredEmployeeList] = useState(employeeList);

  // Initial form values
  const initialValues = {
    name: initialData?.team_name || null,
    team_lead_id: initialData?.team_lead_id || null,
    description: initialData?.team_description || null,
    team_members: initialData?.employees?.length > 0 ? initialData?.employees.map(emp => emp.employee_id) : null,
  };

  // Filter out team lead from employee list initially if one is set
  useEffect(() => {
    if (initialData?.team_lead_id) {
      const filtered = employeeList.filter(
        employee => employee.value !== initialData.team_lead_id
      );
      setFilteredEmployeeList(filtered);
    } else {
      setFilteredEmployeeList(employeeList);
    }
  }, [employeeList, initialData]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    team_lead_id: Yup.string().required("Team Lead is required"),
    description: Yup.string().nullable(),
  });


  useEffect(() => {
        (async () => {
          const resEmployee = await getEmployeeList({
            params: { ...(!isAdmin && { employee_id: cookies.euid }),status: JSON.stringify(["Active"]) },
            token: cookies.e_t,
          });
  
           setEmployeeList(resEmployee?.employeeResponseValueLabel);
           setFilteredEmployeeList(resEmployee?.employeeResponseValueLabel);
      })();
    }, []);
    // console.log("employeeList3", employeeList);


    
  const handleSubmit = async ({ values, resetForm }) => {
    try {
      const res = await postData({
        endpoint: "Team/createTeam",
        data: {
          ...values,
        },
        token: cookies.e_t,
      });

      if (res) {
        toast.success("Team Created Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        setIsSubmitting(false);
        onClose();
        refetchData();
      }
    } catch (err) {}
  };

  const handleEdit = async (values) => {
    try {
      const res = await patchData({
        endpoint: "Team/editTeam",
        token: cookies.e_t,
        data: values,
        params: { team_id: initialData?.team_id },
      });

      if (res.status) {
        toast.success("Team Updated Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        refetchData();
      } else {
        toast.error(res.message, { style: confimationStyles, duration: 1000 });
      }

      onClose();
    } catch (error) {}
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { resetForm }) => {
        {
          initialData
            ? handleEdit(values)
            : handleSubmit({ values, resetForm });
        }
        resetForm();
        onFormDirty(false); // Reset form dirty state
      }}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
    >
      {({ values, setFieldValue, touched, errors, handleBlur, setFieldTouched , dirty }) => (
        <>
          <FormObserver onFormDirty={onFormDirty} />
          <Form>
            {/* Name */}

            <div className="row gx-4">
              <InputLayout>
                <label className="required-field">Team Name</label>
                <Field name="name" />
                <Error error={errors.name} />
              </InputLayout>

              <InputLayout>
                <label className="required-field">Team Lead</label>
                <SelectDropdown 
                  data={employeeList}
                  isClearable={true}
                  onClear={() => {
                    setFieldValue("team_lead_id", null);
                    // Reset filtered list when clearing team lead
                    setFilteredEmployeeList(employeeList);
                  }}
                  onChange={(option) => {
                    setFieldValue("team_lead_id", option);
                    
                    // Filter selected team lead from team members list
                    if (option) {
                      const newFilteredList = employeeList.filter(
                        employee => employee.value !== option
                      );
                      setFilteredEmployeeList(newFilteredList);
                      
                      // Also remove team lead from selected team members if present
                      if (values.team_members && Array.isArray(values.team_members)) {
                        const updatedMembers = values.team_members.filter(
                          memberId => memberId !== option
                        );
                        setFieldValue("team_members", updatedMembers);
                      }
                    } else {
                      setFilteredEmployeeList(employeeList);
                    }
                  }}
                  selectedValue={values.team_lead_id}
                  handleBlur={(e) => {
                    setFieldTouched("team_lead_id", true);
                    handleBlur(e);
                  }}
                  isError={touched.team_lead_id && errors.team_lead_id}
                />
                <Error error={errors.team_lead_id} />
              </InputLayout>
            </div>

            <div className="row gx-4 mt-3">
              <InputLayout>
                <label>Team Members</label>
                <SelectDropdown 
                  multiSelect 
                  data={filteredEmployeeList} // Use filtered list here
                  onChange={(option) => {
                    setFieldValue("team_members", option);
                  }}
                  handleBlur={(e) => {
                    setFieldTouched("team_members", true);
                    handleBlur(e);
                  }}
                  selectedValue={values.team_members}
                  onClear={() => setFieldValue("team_members", [])}
                  isError={touched.team_members && errors.team_members}
                />
                <Error error={errors.team_members} />
              </InputLayout>
            </div>

            <div className="row gx-4 mt-3">
              <InputLayout>
                <label>Description</label>
                <Field name="description" as="textarea" />
                <Error error={errors.designation} />
              </InputLayout>
            </div>

            <div className="modal-footer mt-4 px-4">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => onClose()}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting || !dirty}
              >
                {initialData ? "Update" : "Save"}
              </button>
            </div>
            {/* Submit Button */}
          </Form>
        </>
      )}
    </Formik>
  );
};

export default TeamForm;
